import { ReactElement } from 'react';
import { FieldProps, ErrorMessage, useFormikContext, getIn } from 'formik';

import classnames from 'classnames';
import { ReactComponent as DropdownIcon } from '../../images/dropdown.svg';
import styles from './DropdownMenu.module.scss';

interface iProps extends FieldProps {
  title: string;
  isMandatory: boolean;
  disabled: boolean;
  defaultOption: boolean;
  displayText: { value: string; display: string }[];
  changeOption?: () => void;
  isOptional?: boolean;
}

const DropdownMenu = ({ field, form, title, isMandatory, isOptional = false, disabled, defaultOption, displayText, changeOption }: iProps): ReactElement => {
  const { errors, touched, values }: { errors: any; touched: any; values: any } = useFormikContext();
  const touchedError = getIn(touched, field.name);
  const hasError = getIn(errors, field.name);
  const defaultValue = getIn(values, field.name);

  return (
    <div
      className={classnames({
        [styles.container]: true,
        [styles.titlePresent]: title,
      })}>
      {title && (
        <div
          className={classnames({
            [styles.title]: true,
            [styles.titleError]: hasError && touchedError,
          })}>
          <span className={styles.titleBold}>{title}</span>
          {(!isMandatory || isOptional) && <span className={styles.optional}> ( optional )</span>}
        </div>
      )}
      <div className={styles.selectContainer}>
        <select
          required={isMandatory}
          className={classnames({ [styles.inputError]: hasError && touchedError })}
          disabled={disabled}
          onChange={(e) => {
            if (changeOption) changeOption();
            form.setFieldTouched(field.name);
            form.setFieldValue(field.name, e.target.value);
          }}
          value={defaultValue}
          aria-label="Select">
          {defaultOption && (
            <option hidden value="">
              Please Select
            </option>
          )}
          {displayText.map((option) => (
            <option value={option.value} key={option.value}>
              {option.display}
            </option>
          ))}
        </select>
        <DropdownIcon className={styles.arrowIcon} />
      </div>
      <ErrorMessage className={styles.errorMsg} name={field.name} component="span" />
    </div>
  );
};

export default DropdownMenu;
